import axios, { AxiosInstance } from 'axios';
import { v4 as uuidv4 } from 'uuid';
import { attachAuthInterceptor } from '@shared/auth/tokenRefresh';

const axiosClient: AxiosInstance = axios.create();

axiosClient.interceptors.request.use(
    (config) => {
        config.headers['x-nq-correlation-id'] = uuidv4();
        return config;
    }, null, { synchronous: true }
    // When you add request interceptors, they are presumed to be asynchronous by default. This can cause a delay in the execution of your axios request when the main thread is blocked (a promise is created under the hood for the interceptor and your request gets put at the bottom of the call stack). If your request interceptors are synchronous you can add a flag to the options object that will tell axios to run the code synchronously and avoid any delays in request execution.
    // https://github.com/axios/axios#interceptors
);

// Reactive token refresh: on 401/403, refresh once and retry; otherwise clear
// the session and redirect to login. A full navigation also resets in-memory
// reporter/Faro state cleanly.
attachAuthInterceptor(axiosClient, {
    refreshUrl: '/api/auth/refresh',
    onLogout: () => {
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('refreshToken');
        delete axiosClient.defaults.headers.common['Authorization'];
        window.location.assign('/login');
    },
});

export default axiosClient;
